import { TehcnicianNoteLink } from 'types';
import { baseQuery } from '../baseQuery';

type PostTechnicianPayload = {
  techId: number;
  notes: string;
  note_type: number;
  notesLinkTypes?: TehcnicianNoteLink[];
};

export const postTechnicianNote = async (payload: PostTechnicianPayload) => {
  const { techId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/notes/${techId}`, {
    type: 'POST',
    body: {
      ...rest,
    },
  });

  return data;
};
